// extracted by mini-css-extract-plugin
module.exports = {"sandbox":"pci__sandbox___3p7Du","isReadOnly":"pci__isReadOnly___1NTTR","isCorrect":"pci__isCorrect___Nwq-v","isNotCorrect":"pci__isNotCorrect___1r19_"};